import { useEffect, useState } from "react";
import "./quoteOrderItemDetail.scss";
import Input from "../../../../../components/Inputs/Input";
import { formatCurrency } from "../../../../../utils/utils";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";
import { setQuoteDetails, updateQuoteDetail } from "../../../../../redux/features/quoteEntry/quoteEntrySlice";
import MultioptionButton from "../../../../../components/Buttons/MultioptionButton";
import { Checkbox, FormControlLabel } from "@mui/material";
import { updateRFQDetails } from "../../../Services/quoteEntryService";
import { useSnackBar } from "../../../../../hooks/useSnackBar";

export const QuoteOrderItemDetail = ({ data, parentQuoteId, isLast  , isLastDetail}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [form, setForm] = useState({
    part_number: "",
    description: "",
    quantity_required: 0,
    uom_abrevation: 0,
    lead_days: 0,
    currency: null,
    currency_id: null,
    unit_cost: 0,
    discount_applied: 0,
    duty: 0,
    freight_cost: 0,
    tax_included: 0,
    subTotal: 0,
    total_cost: 0,

    //percentages and others values than doesn't come from backend
    discount_percentage: 0,
    tax_percentage: 0,
    available_qty: null,
  });
  const [edition, setEdition] = useState(false);
  const [currencyDrop, setCurrencyDrop] = useState(null);
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);
  const { successMsg, warningMsg } = useSnackBar();

  // functions
  const getDropdownConfigCurrency = async () => {
    let id = 74;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCurrencyDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([getDropdownConfigCurrency()]);
    return results;
  };

  const [isDirty, setIsDirty] = useState(false);
const handleFormChange = (data) => {
  if (!data.id) return; 

  dispatch(
    updateQuoteDetail({
      quoteId: parentQuoteId,
      detailId: data.id,
      newData: data,
    })
  );
};

  const handleFormChanges = (e) => {
    setIsDirty(true);
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    setForm((prev) => {
      const updatedForm = {
        ...prev,
        [name]: numericValue,
      };

      const subTotal = updatedForm.quantity_required * updatedForm.unit_cost;

      if (name === "discount_applied") {
        updatedForm.discount_percentage = subTotal
          ? (numericValue / subTotal) * 100
          : 0;
      } else if (name === "discount_percentage") {
        updatedForm.discount_applied = (numericValue / 100) * subTotal;
      }

      if (name === "tax_included") {
        updatedForm.tax_percentage = subTotal
          ? (numericValue / subTotal) * 100
          : 0;
      } else if (name === "tax_percentage") {
        updatedForm.tax_included = (numericValue / 100) * subTotal;
      }

      updatedForm.subTotal = subTotal;

      updatedForm.total_cost =
        subTotal -
        updatedForm.discount_applied +
        updatedForm.tax_included +
        updatedForm.duty +
        updatedForm.freight_cost;

      handleFormChange(updatedForm);
      return updatedForm;
    });
  };

  const preloadForm = (data) => {
    const subTotal = data.quantity_required * data.unit_cost;

    const discount_percentage = subTotal
      ? (data.discount_applied / subTotal) * 100
      : 0;

    const tax_percentage = subTotal ? (data.tax_included / subTotal) * 100 : 0;

    setForm((prev) => {
      const updated = {
        ...prev,
        ...data,
        // currency_id : data.currency_id,
        subTotal,
        discount_percentage,
        tax_percentage,
        available_qty: data.quantity_required,

        total_cost:
          subTotal -
          data.discount_applied +
          data.tax_included +
          data.duty +
          data.freight_cost,
      };

      return updated;
    });
  };

  const handlePartAvailability = (e) => {
    const updatedQty = parseInt(e.target.value);

    if (updatedQty == 0) {
      setForm((prev) => {
        return {
          ...prev,
          lead_days: 0,
          currency: null,
          currency_id: null,
          unit_cost: 0,
          discount_applied: 0,
          discount_percentage: 0,
          tax_included: 0,
          tax_percentage: 0,
          duty: 0,
          freight_cost: 0,
          available_qty: updatedQty,
        };
      });
      // setEdition(false)
    } else if (updatedQty > 0) {
      setForm((prev) => {
        return {
          ...prev,
          available_qty: updatedQty,
        };
      });
    }
  };

  const updateDetail = async (typeOfSave) => {
    const body = [
      {
        id: data.id,
        responseDate: new Date(),
        unitCost: form.unit_cost,
        taxIncluded: form.tax_included,
        leadDays: form.lead_days,
        unitCostdiscountApplied: form.discount_applied,
        currencyId: form.currency_id,
        availability: form.available_qty,
      },
    ];

    let request = await updateRFQDetails(body);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      successMsg("Data Updated", "The Detail data has been sent successfully.");
      if (typeOfSave == "finish") {
        setEdition(false);
        setIsOpen(false);
      } else {
        setEdition(true);
        setIsOpen(true);
      }
    }
  };

  // effects
useEffect(() => {
  if (!isDirty) return;
  const event = { target: { name: "unit_cost", value: form.unit_cost } };
  handleFormChanges(event);
}, [form.unit_cost]);

  useEffect(() => {
    handleFormChange(form);
  }, [form.currency_id]);
  useEffect(() => {
    if (data.status == "Pending") {
      setDisable(false);
    } else if (data.status == "Ordered" || data.status == "Quoted") {
      setDisable(true);
    }
    getAllDropdowns();
    preloadForm(data);
  }, []);

  const cancelEdition = () => {
    setEdition(false);
  };
  const multiOptionsBtn = [
    { label: "Save and Finish", icon: "icon-save", id: "save" },
    {
      label: "Save and Continue Editing",
      icon: "icon-save",
      id: "save-continue",
    },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => updateDetail("finish"),
    "save-continue": () => updateDetail("continue"),
    cancel: () => cancelEdition(),
  };

  return (
    <div className="quote-order-item-detail">
      <div
        className="quote-order-item-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p>{form.part_number || "--"}</p>
        <p>{form.description || "--"}</p>
        <p>{form.quantity_required + " " + form.uom_abrevation || "--"}</p>
        <p>{form.available_qty + " " + form.uom_abrevation || "--"}</p>
        <p>{form.lead_days || "--"}</p>
        <p>{form.currency || "--"}</p>
        <p>{formatCurrency(form.unit_cost, form.currency ?? "USD")}</p>
        <p>{formatCurrency(form.discount_applied, form.currency ?? "USD")}</p>
        <p>{formatCurrency(form.duty, form.currency ?? "USD")}</p>
        <p>{formatCurrency(form.freight_cost, form.currency ?? "USD")}</p>
        <p>{formatCurrency(form.tax_included, form.currency ?? "USD")}</p>
        <p>{formatCurrency(form.subTotal, form.currency ?? "USD")}</p>
        <p
          style={{
            textAlign: "end",
            color: "#29ABE2",
            fontWeight: "700",
            fontSize: ".7rem",
          }}
        >
          {formatCurrency(form.total_cost, form.currency)}
        </p>
      </div>
      {isOpen && (
        <div className={`quote-order-item-content ${isOpen ? "open" : ""}`}>
          <div className="quote-order-item-detail-edit-cont">
            <h3>General Information</h3>
            {(data.status === "Pending" ||
              data.status === "Partially Quoted" ||
              data.status === "No Availability") &&
              (!edition ? (
                <button onClick={(e) => setEdition(true)}>
                  <i className="icon-edit"></i>
                  Edit
                </button>
              ) : (
                <MultioptionButton
                  buttons={multiOptionsBtn}
                  buttonCallbacks={buttonsCallback}
                />
              ))}
          </div>
          <section className="quote-order-item-detail-form">
            <div
              style={{
                height: "45%",
                width: "100%",
                borderBottom: "1px solid #DDDDDD",
              }}
            >
              <h2
                style={{
                  fontSize: "calc(var(--subtitle-size) - .2rem)",
                  fontWeight: "500",
                  color: "var(--black-mid)",
                  // width: "15rem",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "auto",
                }}
              >
                Add Quote Info
              </h2>

              <p>QTY Quoted</p>
              <Input
                style={{
                  width: "6rem",
                }}
                isNumeric={true}
                limit={form.quantity_required}
                name={""}
                disabled={disable || !edition}
                value={form.available_qty}
                onChange={(e) => {
                  handlePartAvailability(e);
                }}
                localizedFormat={true}
              ></Input>
              <p
                style={{
                  marginRight: ".5rem",
                  fontWeight: "700",
                }}
              >
                {form.uom_abrevation}
              </p>
              <p>Lead Days</p>
              <Input
                style={{
                  width: "4rem",
                }}
                disabled={disable || !edition || form.available_qty == 0}
                value={form.lead_days}
                name={"lead_days"}
                isNumeric={true}
                onChange={handleFormChanges}
              />
              <p>Currency</p>
              <div
                style={{
                  width: "5rem",
                }}
              >
                {currencyDrop ? (
                  <Dropdowns
                    disabled={disable || !edition || form.available_qty == 0}
                    hideLabel={true}
                    data={currencyDrop}
                    onOptionSelect={(e) => {
                      setForm((prev) => {
                        const data = {
                          ...prev,
                          currency: e.prefix,
                          currency_id: e.id,
                        };

                        return data;
                      });
                    }}
                    preSelectValue={form.currency_id}
                  />
                ) : (
                  <Skeleton height={"2rem"} />
                )}
              </div>
              <p>Unit Cost</p>
              <Input
                style={{
                  width: "10rem",
                }}
                disabled={disable || !edition || form.available_qty == 0}
                value={form.unit_cost}
                name={"unit_cost"}
                isNumeric={true}
                onChange={handleFormChanges}
              />
              <p>Sub Total</p>
              <Input
                disabled={true}
                style={{
                  width: "14rem",
                }}
                value={form.subTotal}
                name={"subTotal"}
                isNumeric={true}
                onChange={handleFormChanges}
              />
            </div>

            <div
              style={{
                height: "45%",
                width: "100%",
              }}
            >
              <h2
                style={{
                  fontSize: "calc(var(--subtitle-size) - .2rem)",
                  fontWeight: "500",
                  color: "var(--black-mid)",
                  // width: "13.7rem",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "auto",
                }}
              >
                Charges & Discounts
              </h2>
              <p>Discount</p>
              <Input
                isPercentage={true}
                style={{
                  width: "4rem",
                }}
                value={form.discount_percentage}
                name={"discount_percentage"}
                isNumeric={true}
                onChange={handleFormChanges}
                disabled={disable || !edition || form.available_qty == 0}
              />
              <Input
                style={{
                  width: "8rem",
                }}
                value={form.discount_applied}
                name={"discount_applied"}
                isNumeric={true}
                onChange={handleFormChanges}
                disabled={disable || !edition || form.available_qty == 0}
              />
              <p>Tax</p>
              <Input
                isPercentage={true}
                style={{
                  width: "4rem",
                }}
                value={form.tax_percentage}
                name={"tax_percentage"}
                isNumeric={true}
                onChange={handleFormChanges}
                disabled={disable || !edition || form.available_qty == 0}
              />
              <Input
                style={{
                  width: "8.8rem",
                }}
                value={form.tax_included}
                name={"tax_included"}
                isNumeric={true}
                onChange={handleFormChanges}
                disabled={disable || !edition || form.available_qty == 0}
              />
              <p>Duty</p>
              <Input
                style={{
                  width: "10.2rem",
                }}
                value={form.duty}
                name={"duty"}
                isNumeric={true}
                onChange={handleFormChanges}
                disabled={disable || !edition || form.available_qty == 0}
              />
              <p>Freight Cost</p>
              <Input
                style={{
                  width: "14rem",
                }}
                value={form.freight_cost}
                name={"freight_cost"}
                isNumeric={true}
                onChange={handleFormChanges}
                disabled={disable || !edition || form.available_qty == 0}
              />
            </div>
          </section>
        </div>
      )}
      {isLast && isLastDetail && data.status == "Pending" ? 
        <div style={{ height: "3rem" }} /> 
      : ""}
    </div>
  );
};
